import { Link } from 'react-router-dom';
import { Mail, Phone, MessageCircle, Clock, MapPin, Building } from 'lucide-react';

export function GlobalFooter() {
  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Section 1 – Talis'on Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">TALIS'ON SERVICES</h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Your trusted partner for career success. We provide expert coaching, guaranteed interviews, and comprehensive support to help you secure your dream role.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <Clock className="h-4 w-4 text-gray-500 flex-shrink-0" />
              <span>Mon - Fri: 9:00 AM - 5:00 PM GMT</span>
            </div>
          </div>

          {/* Section 2 – Our Address */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">OUR ADDRESS</h3>
            <div className="flex items-start gap-2 text-sm text-gray-400 leading-relaxed">
              <MapPin className="h-4 w-4 text-gray-500 flex-shrink-0 mt-1" />
              <div>
                <p className="font-semibold text-gray-300">TALIS'ON SERVICES LTD</p>
                <p>20 Swan Street, First Floor</p>
                <p>Swan Street</p>
                <p>Manchester</p>
                <p>M4 5JW</p>
                <p>United Kingdom</p>
                <p className="mt-2">
                  <Building className="h-3.5 w-3.5 inline mr-1 text-gray-500" />
                  Company no: 15479376
                </p>
              </div>
            </div>
          </div>

          {/* Section 3 – Contact Us */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">CONTACT US</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:Support@talisonservices.co.uk"
                  className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
                >
                  <Mail className="h-4 w-4 text-gray-500 flex-shrink-0" />
                  Support@talisonservices.co.uk
                </a>
              </li>
              <li>
                <a
                  href="tel:07767123990"
                  className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
                >
                  <Phone className="h-4 w-4 text-gray-500 flex-shrink-0" />
                  07767 123 990
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/447767123990"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-sm text-green-400 hover:text-green-300 transition-colors"
                >
                  <MessageCircle className="h-4 w-4 flex-shrink-0" />
                  Chat on WhatsApp
                </a>
              </li>
            </ul>
          </div>

          {/* Section 4 – Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">QUICK LINKS</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#services" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 text-center">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} Talis'on Services Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
